<!--  -->
<template>
<div>
  <div class="faqs">
     <div class="banner">
      <div class="banner-text">
        <p class="title">{{$t('safety324')}}</p>
      </div>
    </div>
    <div class="tab-fix">
      <ul class="tab-box">
        <li v-for="item in navData" :key="item.id" @click="current = item.id" :class="{active: item.id === current}">{{item.name}}</li>
      </ul>
    </div>
    <div class="row-line" v-show="current === 'tab-1'">
      <h2 class="title">{{$t('safety325')}}</h2>
      <p class="fu-title">{{$t('safety327')}}</p>
      <p class="content">{{$t('safety328')}}</p>
      <p class="fu-title">{{$t('safety329')}}</p>
      <p class="content">{{$t('safety330')}}</p>
      <p class="fu-title">{{$t('safety331')}}</p>
      <p class="content">{{$t('safety332')}}<br>
{{$t('safety333')}}<br>
{{$t('safety334')}}<br>
{{$t('safety335')}}</p>
    </div>
    <div class="row-line" v-show="current === 'tab-2'">
      <h2 class="title">{{$t('safety336')}}</h2>
      <p class="fu-title">{{$t('safety337')}}</p>
      <p class="content">{{$t('safety338')}}</p>
      <p class="fu-title">{{$t('safety339')}}</p>
      <p class="content">{{$t('safety340')}}</p>
      <p class="fu-title">{{$t('safety341')}}</p>
      <p class="content">{{$t('safety342')}}</p>
      <p class="fu-title">{{$t('safety343')}}</p>
      <p class="content">{{$t('safety344')}}</p>
    </div>
    <!-- <div class="row-line" v-show="current === 'tab-3'">
      <h2 class="title">Using LivU</h2>
      <p class="fu-title">• How do I buy coins?</p>
      <p class="content">Click the “Buy Coins” button in the app on your profile page and you will be able to recharge.</p>
      <p class="fu-title">• Why didn’t I receive coins after recharging?</p>
      <p class="content">oPlease restart or re-login to the app<br>oCheck your internet connection and whether the money was deducted successfully.<br>oIf the above 2 steps don’t work, please contact our customer service by going to the messaging panel in the app or <a href="mailto:safety@LivU.me?subject=LivU Safety Request">contact us on Email.</a></p>
      <p class="fu-title">• Why can’t I buy coins?</p>
      <p class="content">oCheck your internet connection and update the app to the latest version.<br>oRestart your device and re-login to the app.<br>oContact Google Play or Apple Store to check if your account is activated.<br>oIf the above 3 steps don’t work, please contact our customer service by going to the messaging panel in the app or <a href="mailto:safety@LivU.me?subject=LivU Safety Request">contact us on Email.</a></p>
      <p class="fu-title">• Why am I matching with people in other countries?</p>
      <p class="content">LivU is a global platform, meaning you can match with people around the world at any time. It is not possible to limit your matching area to just your country, however, this is a feature we are working on – when it’s ready we’ll let you know.</p>
      <p class="fu-title">• Why do I keep getting disconnected?</p>
      <p class="content">Please make sure you have a stable internet connection and if it continues to happen, try restarting your device. Our engineers are always working hard to make sure every user has the best experience possible, if you are still encountering an error please reach out to customer service in the LivU app.</p>
    </div> -->
    <div class="row-line" v-show="current === 'tab-4'">
      <h2 class="title">Safety & Privacy</h2>
      <p class="fu-title">{{$t('safety345')}}</p>
      <p class="content" v-html="$t('safety346')"></p>
      <p class="fu-title">{{$t('safety347')}}</p>
      <p class="content" v-html="$t('safety348')"></p>
      <p class="fu-title">{{$t('safety349')}}</p>
      <p class="content">{{$t('safety350')}}</p>
      <p class="fu-title">{{$t('safety351')}}</p>
      <p class="content" v-html="$t('safety352')"></p>
      <p class="fu-title">{{$t('safety353')}}</p>
      <p class="content">{{$t('safety354')}}</p>
      <p class="fu-title">{{$t('safety355')}}</p>
      <p class="content">{{$t('safety356')}}</p>
      <p class="fu-title">{{$t('safety357')}}</p>
      <p class="content">{{$t('safety358')}}</p>
      <p class="fu-title">{{$t('safety359')}}</p>
      <p class="content">{{$t('safety360')}}</p>
    </div>
  </div>
  <backTop></backTop>
</div>
</template>

<script>
import backTop from './back-top.vue'
export default {
  name: 'faqs',
  components: {
    backTop
  },
  data () {
    return {
      current: 'tab-4',
      navData: [
        {
          name: 'General',
          id: 'tab-1'
        },
        {
          name: 'My Account',
          id: 'tab-2'
        },
        // {
        //   name: 'Using LivU',
        //   id: 'tab-3'
        // },
        {
          name: 'Safety & Privacy',
          id: 'tab-4'
        }
      ]
    }
  },
  methods: {
  }
}

</script>
<style lang='scss' scoped>
@import '@/assets/style/vars.scss';
@media (min-width: 750px) {
  .to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
  .banner {
    width: 100%;
    height: 400px;
    background: url('../assets/images/banner-8.png') no-repeat;
    background-size:  100% 100%;
    .title{
        color: #ffffff;
        font-size: 45px;
        font-weight: bold;
        text-align: center;
        line-height: 400px;
        margin-bottom: 40px;
      }
  }
  .faqs {
    width: 1000px;
    margin: 100px auto 50px auto;
    // margin: 50px auto 50px auto;
    padding-bottom: 40px;
    .tab-fix {
      width: 100%;
      position: fixed;
      top: 120px;
      left: 0;
      padding-top: 40px;
      padding-bottom: 30px;
      background-color: #ffffff;
    }
    .tab-box {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        li {
          margin-right: 30px;
          text-align: center;
          cursor: pointer;
          font-size: 24px;
          font-weight: bold;
          color: #333;
          position: relative;
          &.active::before {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -10px;
            width: 38px;
            height: 3px;
            background-color: $primary;
            transform: translateX(-50%)
          }
        }
      }
    .row-line {
      margin-bottom: 40px;
      text-align: left;
      .title {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        margin-bottom: 25px;
      }
      .fu-title {
        color: #333;
        font-size: 24px;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .content {
        font-size: 24px;
        color: #5e5e5e;
        margin-bottom: 20px;
        line-height: 28px;
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        &>a {
          display: inline-block;
          width: 282px;
          height: 60px;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          border-radius: 8px;
          text-decoration: none;
        }
      }
    }
  }
}
@media (max-width: 750px) {
  .to-top{
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
    background: center center / contain no-repeat transparent;
    transition: opacity 300ms ease 0s;
    cursor: pointer;
    z-index: 7;
}
  .banner {
    width: 100%;
    height: 100px;
    background: url('../assets/images/banner-8.png') no-repeat;
    background-size:  100% 100%;
    .title{
        color: #ffffff;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        line-height: 100px;
        margin-bottom: 40px;
      }
  }
  .tab-fix {
      width: 100%;
      position: fixed;
      top: 56px;
      left: 0;
      padding: 30px 25px 25px 25px;
      background-color: #ffffff;
    }
  .faqs {
    // padding:30px 25px 10px 25px;
    padding:80px 25px 10px 25px;
    .tab-box {
        display: flex;
        li {
          margin-right: 18px;
          text-align: center;
          cursor: pointer;
          font-size: 12px;
          font-weight: bold;
          color: #333;
          position: relative;
          &.active::before {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -10px;
            width: 38px;
            height: 3px;
            background-color: $primary;
            transform: translateX(-50%)
          }
        }
      }
    .row-line {
      margin-bottom: 40px;
      text-align: left;
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin-bottom: 13px;
      }
      .fu-title {
        color: #333;
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .content {
        font-size: 14px;
        color: #5e5e5e;
        margin-bottom: 10px;
        line-height: 18px;
      }
      .row-line-button {
        text-align: right;
        margin-top: 20px;
        &>a {
          display: inline-block;
          width: 282px;
          height: 60px;
          background-color: $primary;
          color: #fff;
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          border-radius: 8px;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
